/**
 * ForgotPasswordForm — Phase E split (May 6, 2026).
 *
 * Presentational form. State is owned by the parent (`AuthDialog`).
 * Markup, classNames, data-testids, and submit semantics are
 * byte-identical to the previous monolithic `AuthModals` component.
 */
import { Mail } from 'lucide-react';
import { Button } from '@/ui/button';
import { Input } from '@/ui/input';
import { Label } from '@/ui/label';
import { DialogBody, DialogFooter } from '@/ui/dialog';

const ForgotPasswordForm = ({
  email,
  authLoading,
  onEmailChange,
  onSubmit,
  onSwitchToSignIn,
}) => (
  <form onSubmit={onSubmit} className="flex flex-col flex-1 min-h-0">
    <DialogBody className="space-y-4">
      <div>
        <Label className="text-slate-300">Email</Label>
        <div className="relative mt-1">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
          <Input
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder="your@email.com"
            className="pl-10 bg-slate-900 border-slate-700 text-white"
            data-testid="forgot-email-input"
          />
        </div>
      </div>

      <div className="text-center">
        <button
          type="button"
          onClick={onSwitchToSignIn}
          className="text-sm text-teal-400 hover:text-teal-300"
          data-testid="ready-to-login-link"
        >
          Ready to LogIn?
        </button>
      </div>
    </DialogBody>

    <DialogFooter className="border-slate-700 bg-slate-800">
      <Button
        type="submit"
        disabled={authLoading}
        className="w-full bg-teal-500 hover:bg-teal-400 text-slate-900"
        data-testid="forgot-submit-btn"
      >
        {authLoading ? 'Sending...' : 'Send'}
      </Button>
    </DialogFooter>
  </form>
);

export default ForgotPasswordForm;
